module.exports = __webpack_public_path__ + "assets/a81cd4dbbed8f12d9eec6da41f0da4b0.png";